module.exports = __webpack_public_path__ + "Times_Education_Excellence_2019-c24c65ad.webp";